import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { defaultTo, compose, isNil } from 'ramda';

import { handleErrorBase, handleSuccessBase } from '../../../../util/forms';
import { routes } from '../../../../routes';
import { apiPayCertificationFees } from '../../../../api/certification';

import Card from '../../../../components/Card';
import DiscountForm from '../../../../components/DiscountForm';
import StripeCheckout from '../../../../components/StripeCheckout';
import { toCurrency } from '../../../../util/helpers';
import { apiGetRenewalDiscount } from '../../../../api/discount';
import { isNilOrEmpty } from '../../../../util/redux';
import FancyRadio from '../../../../components/Forms/FancyRadio';
import CodeOfEthics from '../../../../components/CodeOfEthics';

class Pay extends Component {
  static propTypes = {
    renewal: PropTypes.object,
    certifications: PropTypes.array,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      year: props.renewal.year,
      price: props.renewal.payment / 100,
      extraPrice: props.renewal.extraPayment / 100,
      extraYear: props.renewal.extraYear,
      payExtra: props.renewal.payment > 0 ? false : true,
      codeOfEthicsName: '',
      codeOfEthicsSignature: '',
      codeOfEthicsSignatureDate: '',
      discount: {},
    };
  }

  render() {
    const {
      year,
      price,
      discount,
      extraPrice,
      extraYear,
      payExtra,
      codeOfEthicsName,
      codeOfEthicsSignature,
      codeOfEthicsSignatureDate,
    } = this.state;
    const hasFee = price > 0 || !isNilOrEmpty(discount);
    const hasExtra = extraPrice > 0;

    return (
      <Card className="container">
        <Card.Header>Pay your certification fees</Card.Header>
        <Card.Body>
          <p>
            Annual fees* are due each year on June 30.
            {hasExtra
              ? ' You have the option of a two-year pre-payment that locks in the current rate (maximum two-year payment only). '
              : ' '}
            Professionals who are dual certified pay one annual certification fee (whichever is the greater of the two).
          </p>
          <p>
            Late Fees: Late fees will be incurred for each month that an annual fee is not paid. After six months of
            non-payment, your certification will be revoked.
          </p>
          {!hasFee && !hasExtra ? (
            <p className="font-weight-bold">All of your certifications are up to date.</p>
          ) : (
            <Fragment>
              {hasFee && (
                <FancyRadio
                  name="payExtra"
                  label={`${year} Fee: ${toCurrency(price)}`}
                  description="This fee is required"
                  value={false}
                  checked={payExtra}
                  onChange={(choice) => this.setState({ payExtra: choice })}
                />
              )}
              {hasExtra && (
                <FancyRadio
                  name="payExtra"
                  label={
                    hasFee
                      ? `${year} + ${extraYear} Fees: ${toCurrency(price + extraPrice)}`
                      : `${extraYear} Fee: ${toCurrency(extraPrice)}`
                  }
                  description={
                    hasFee ? 'Pay both fees now to lock in the current rate' : `Pay ${extraYear}'s fee early`
                  }
                  value={true}
                  checked={payExtra}
                  onChange={(choice) => this.setState({ payExtra: choice })}
                />
              )}
            </Fragment>
          )}

          <p className="tip">
            *Annual Certification Fees and any Continue Education Program paid through Sage Financial Solutions® are non-refundable.
          </p>

          {hasFee && (
            <DiscountForm
              discount={discount}
              checkDiscount={(discountCode) => apiGetRenewalDiscount({ discountCode })}
              update={(data) => {
                this.setState({ price: data.payment / 100, discount: defaultTo({}, data.discount) });
              }}
            />
          )}

          {(hasFee || hasExtra) && (
            <Fragment>
              <hr />
              <h3>
                Please resign Sage Financial Solutions
                <sup>®</sup> Counselor's Code of Ethics
              </h3>
              <CodeOfEthics
                handleBlur={() => {}}
                handleChange={({ target }) => this.setState({ [target.name]: target.value })}
                name={codeOfEthicsName}
                signature={codeOfEthicsSignature}
                date={codeOfEthicsSignatureDate}
              />
            </Fragment>
          )}

          {(hasFee || hasExtra) && (
            <div className="text-right mt-5">
              <StripeCheckout
                name="Sage Financial Solutions"
                description="Certification Renewal"
                amount={payExtra ? price + extraPrice : price}
                disabled={
                  isNilOrEmpty(codeOfEthicsName) ||
                  isNilOrEmpty(codeOfEthicsSignature) ||
                  isNilOrEmpty(codeOfEthicsSignatureDate)
                }
                pay={(token, overrides = {}) =>
                  apiPayCertificationFees({ token, discountCode: discount.code, payExtra, ...overrides })
                    .then(() => (window.location = routes.dashboardPaid))
                    .then(() => handleSuccessBase())
                    .catch(() => handleErrorBase())
                }
              />
            </div>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default compose(withRouter)(Pay);
